// @flow
import { Record } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

type InvestmentPerformanceTypeV2 = {
  id: string,

  accountId: string,
  startOn: string,
  endOn: string,
  percentChange: number,
  amountChange: number,
};

export type InvestmentPerformanceV2 = RecordOf<InvestmentPerformanceTypeV2>;
export const mkInvestmentPerformanceV2: RecordFactory<InvestmentPerformanceV2> =
  Record({
    id: undefined,

    accountId: undefined,
    startOn: undefined,
    endOn: undefined,
    percentChange: undefined,
    amountChange: undefined,
  });
